import { render } from "./AnalysisTab.vue?vue&type=template&id=37de8d1d"
import script from "./AnalysisTab.vue?vue&type=script&lang=js"
export * from "./AnalysisTab.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__